export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/b3dc542ec1b5794376b3d1da54a4e35b.svg";